import React from "react";
import { Route } from "react-router-dom";
import FPOHomepage from "../../screens/fpo/FPOHomepage";
import FPOProfileMain from "../../screens/fpo/FPOProfileMain";
import FPOData from "../../screens/fpo/FPOData";
import CreateOrganization from "../../components/CreateOrganization";
import AddFPOMember from "../../screens/fpo/AddFPOMember";
import DirectorsCeoList from "../../screens/fpo/DirectorsCeoList";
import AddFPOFarmerNew from "../../screens/fpo/AddFPOFarmerNew";
import FarmerList from "../../screens/fpo/FarmerList";
import LoansFPO from "../../screens/fpo/LoansFPO";
import SendLoanRequestFPO from "../../screens/fpo/SendLoanRequestFPO";
import LoanProposals from "../../screens/fpo/LoanProposals";
import ViewLoanProposal from "../../screens/fpo/ViewLoanProposal";
import DocumentsScreen from "../../screens/fpo/DocumentsScreen";
import DocumentList from "../../screens/fpo/DocumentList";
import Financials from "../../screens/fpo/Financials";
import FinancialDocuments from "../../screens/fpo/FinancialDocuments";
import MyLoans from "../../screens/lender/MyLoan";
import LoanDocuments from "../../screens/fpo/LoanDocuments";
import Lenders from "../../screens/fpo/Lenders";
import LenderDetails from "../../screens/fpo/LenderDetails";
import BuyingOffers from "../../screens/fpo/BuyingOffers";

export const fpoRoutes = [
  <Route key="fpo-home" path="/" element={<FPOHomepage />} />,
  <Route key="fpo-service" path="service/fpo" element={<FPOProfileMain />} />,
  <Route key="fpo-data" path="fpo/data/" element={<FPOData />} />,
  <Route
    key="fpo-create-organization"
    path="fpo/create-organization/"
    element={<CreateOrganization />}
  />,
  <Route key="fpo-profile" path="fpo/profile/" element={<FPOProfileMain />} />,
  <Route
    key="fpo-members-add"
    path="fpo/members/add"
    element={<AddFPOMember />}
  />,
  <Route
    key="fpo-members"
    path="fpo/members/"
    element={<DirectorsCeoList />}
  />,
  <Route
    key="fpo-farmers-add"
    path="fpo/farmers/add"
    element={<AddFPOFarmerNew />}
  />,
  <Route key="fpo-farmers" path="fpo/farmers/" element={<FarmerList />} />,
  <Route key="fpo-loans" path="fpo/loans/" element={<LoansFPO />} />,
  <Route
    key="fpo-send-loan-request"
    path="fpo/send-loan-request"
    element={<SendLoanRequestFPO />}
  />,
  <Route
    key="fpo-loan-proposals"
    path="fpo/loan-proposals"
    element={<LoanProposals />}
  />,
  <Route
    key="fpo-view-loan-proposal"
    path="fpo/view-loan-proposal/:proposalId"
    element={<ViewLoanProposal />}
  />,
  <Route
    key="fpo-documents"
    path="fpo/documents"
    element={<DocumentsScreen />}
  />,
  <Route
    key="fpo-documents-list"
    path="fpo/documents-list"
    element={<DocumentList />}
  />,
  <Route key="fpo-financials" path="fpo/financials" element={<Financials />} />,
  <Route
    key="fpo-financials-documents"
    path="fpo/financials-documents"
    element={<FinancialDocuments />}
  />,
  <Route key="fpo-my-loans" path="fpo/my-loans" element={<MyLoans />} />,
  <Route
    key="fpo-loan-documents"
    path="fpo/loan-documents"
    element={<LoanDocuments />}
  />,
  <Route key="fpo-all-lenders" path="fpo/all-lenders" element={<Lenders />} />,
  <Route
    key="fpo-lender-details"
    path="fpo/all-lenders/:lenderId"
    element={<LenderDetails />}
  />,
  <Route
    key="fpo-buying-offers"
    path="/fpo/buying-offers"
    element={<BuyingOffers />}
  />,
];
